export default __webpack_public_path__ + "static/media/icon-restaurant-delivery.f096f72c.svg";